import { defineStore } from "pinia";

export const useRecruitmentRequestStore = defineStore('recruitmentRequest', {
  state: () => ({
    recruitmentRequest: {},
    recruitmentRequests: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setRecruitmentRequest(recruitmentRequest) {
      this.recruitmentRequest = recruitmentRequest
    },
    setRecruitmentRequests(recruitmentRequests) {
      this.recruitmentRequests = recruitmentRequests
    },
    addRecruitmentRequest(recruitmentRequest) {
      this.recruitmentRequests.unshift(recruitmentRequest)
    },
    updateRecruitmentRequest(recruitmentRequest) {
      let index = this.recruitmentRequests.findIndex(cl => cl.id === recruitmentRequest.id)
      this.recruitmentRequests.splice(index, 1, recruitmentRequest)
    },
    deleteRecruitmentRequest(recruitmentRequest) {
      let index = this.recruitmentRequests.findIndex(cl => cl.id === recruitmentRequest.id)
      this.recruitmentRequests.splice(index, 1)
    },
  },
});